module.exports = __webpack_public_path__ + "static/homeVentWinter-e0def72ef546bc1b3360f470f80b3570.gif";